/** Client mirror of server culture source constants (data health filtering). */

export const CULTURE_SOURCE_KEYS = Object.freeze({
  ALCALDIA_MEDELLIN_EVENTS: "ALCALDIA_MEDELLIN_EVENTS",
  SECRETARIA_CULTURA_MEDELLIN: "SECRETARIA_CULTURA_MEDELLIN",
  GEOMEDELLIN_CULTURAL_POIS: "GEOMEDELLIN_CULTURAL_POIS",
  OSM_CULTURE_VENUES: "OSM_CULTURE_VENUES",
  MAMM_CALENDAR: "MAMM_CALENDAR",
  MUSEO_ANTIOQUIA_CALENDAR: "MUSEO_ANTIOQUIA_CALENDAR",
  TEATRO_METROPOLITANO_CALENDAR: "TEATRO_METROPOLITANO_CALENDAR",
  TEATRO_PABLO_TOBON_CALENDAR: "TEATRO_PABLO_TOBON_CALENDAR",
  EVENTBRITE_MEDELLIN: "EVENTBRITE_MEDELLIN",
  MEETUP_MEDELLIN: "MEETUP_MEDELLIN",
  COMMUNITY_CULTURE_REPORTS: "COMMUNITY_CULTURE_REPORTS",
  ORGANIZER_CULTURE_SUBMISSIONS: "ORGANIZER_CULTURE_SUBMISSIONS",
  CURATED_MEDELLIN_CULTURE: "CURATED_MEDELLIN_CULTURE",
});

export const CULTURE_SEEDED_SOURCE_KEYS = Object.freeze(Object.values(CULTURE_SOURCE_KEYS));

export const CULTURE_LAYER_IDS = Object.freeze({
  EVENTS: "culture-events",
  VENUES: "culture-venues",
  ROUTES: "culture-routes",
});

export function isCultureDataHealthSource(sourceCode) {
  const normalized = String(sourceCode || "").trim().toUpperCase();
  return CULTURE_SEEDED_SOURCE_KEYS.includes(normalized);
}

export const CULTURE_SOURCE_GROUP_LABELS = {
  culture_registry: "Culture registry",
};

export function cultureSourceGroupLabel(sourceGroup) {
  return CULTURE_SOURCE_GROUP_LABELS[sourceGroup] || null;
}

export function cultureSourceDetailLines(source) {
  const metadata = source?.cultureMetadata;
  if (!metadata) {
    return [];
  }

  const lines = [];
  if (metadata.readinessTier) {
    lines.push(`Readiness tier: ${metadata.readinessTier}`);
  }
  if (metadata.supportsRunNow === true) {
    lines.push("Supports Run Now (Tier A — controls coming in next milestone)");
  } else if (metadata.supportsRunNow === false) {
    lines.push("Does not support Run Now");
  }
  if (metadata.referenceOnly) {
    lines.push("Reference-only source (curated seed workflow)");
  }
  if (metadata.moderationBased) {
    lines.push("Moderation-based source (Culture moderation queue)");
  }
  if (metadata.runnerType) {
    lines.push(`Runner type: ${metadata.runnerType}`);
  }
  if (metadata.status) {
    lines.push(`Registry status: ${metadata.status}`);
  }
  if (metadata.trustLevel) {
    lines.push(`Trust: ${metadata.trustLevel}`);
  }
  if (metadata.isLive === true) {
    lines.push("Live feed enabled");
  } else if (metadata.isLive === false) {
    lines.push("Not live");
  }
  if (metadata.collectorImplemented === true) {
    lines.push("Collector implemented");
  }
  if (metadata.parserImplemented === true) {
    lines.push("Parser implemented");
  }
  if (metadata.envVarName) {
    const presentLabel =
      metadata.envVarPresent === true
        ? "set"
        : metadata.envVarPresent === false
          ? "not set"
          : "optional";
    lines.push(`Env var: ${metadata.envVarName} (${presentLabel})`);
  }
  if (metadata.blockingReasons?.length) {
    lines.push(`Blocking: ${metadata.blockingReasons.join("; ")}`);
  }
  if (metadata.recommendedNextAction) {
    lines.push(`Next action: ${metadata.recommendedNextAction}`);
  }
  if (metadata.lastKnownRunnablePath) {
    lines.push(`CLI path: ${metadata.lastKnownRunnablePath}`);
  }
  if (metadata.healthNote) {
    lines.push(metadata.healthNote);
  }
  return lines;
}
